<template>
  <div
    ref="videoPreview"
    class="video-preview"
    :style="{
      'background-image': `url('${image}')`
    }"
  >
    <!-- popup image -->
    <img class="video-preview__image" :src="image" alt />
    <!-- popup label -->
    <div class="video-preview__time-label">
      {{ text }}
    </div>
  </div>
</template>

<script>
// @group Popup
// Clipping area popup thumbnail
export default {
  name: "PopupImage",
  props: {
    /** popup text  */
    text: {
      type: String,
      default: ""
    },
    /** popup image link */
    image: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      left: 0
    };
  }
};
</script>

<style lang="scss" scoped>
.video-preview {
  display: block;
  position: absolute;
  width: 170px;
  height: 96px;
  z-index: var(--timeline-popup-z);
  background: black no-repeat center;
  background-size: contain;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
}

.hidden {
  display: none;
}
.video-preview__image {
  width: 100%;
  height: 100%;
  /** z-index: 900; */
}

.video-preview__time-label {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}
</style>
